import { Locale } from '@scouts/helpers'

import { FileSubType, FileTypes } from './models'

export const DEFAULT_LOCALE = Locale.ES

export const SUPPORT_EMAIL = 'soporte@taxfix.es'
export const SUPPORT_PHONE_PRIORITY = '+34 911 98 52 73'
/** For "Empresas" pack customers */
export const SUPPORT_PHONE_PRIORITY_COMPANIES = '+34 919 01 72 51'

export const REQUEST_TYPE_CREATE = 'CREATE'
export const REQUEST_TYPE_DELETE = 'DELETE'
export const REQUEST_TYPE_DOWNLOAD = 'DOWNLOAD'
export const REQUEST_TYPE_FETCH = 'FETCH'
export const REQUEST_TYPE_UPDATE = 'UPDATE'
export const REQUEST_TYPE_UPLOAD = 'UPLOAD'
export const REQUEST_TYPE_SEND = 'SEND'

export const ERROR_MESSAGE_UNKNOWN = 'Error desconocido, intenta cargar la página nuevamente'
export const ERROR_MESSAGE_AUTHENTICATION = 'Error de autenticación'
export const ERROR_MESSAGE_UNAUTHORISED = 'Unauthorised, try reloading the page'
export const ERROR_MESSAGE_GENERIC = `Ha habido un error al procesar la solicitud; por favor, contacta a ${SUPPORT_EMAIL}`
export const ERROR_MESSAGE_SAVING = 'Ha habido un problema al guardar la información'
export const ERROR_MESSAGE_DELETING = 'Ha habido un problema al eliminar los datos'
export const ERROR_MESSAGE_DELETING_FILE = 'Ha habido un problema al eliminar el archivo'
export const ERROR_MESSAGE_UPLOADING_FILE = 'Ha habido un problema al subir el archivo'
export const ERROR_MESSAGE_DOWNLOADING_FILE = `Ha habido un problema al descargar el archivo; por favor, contacta a ${SUPPORT_EMAIL}`

export const REQUEST_ERROR_MESSAGES = {
    [REQUEST_TYPE_CREATE]: ERROR_MESSAGE_SAVING,
    [REQUEST_TYPE_DELETE]: ERROR_MESSAGE_DELETING,
    [REQUEST_TYPE_DOWNLOAD]: ERROR_MESSAGE_DOWNLOADING_FILE,
    [REQUEST_TYPE_FETCH]: ERROR_MESSAGE_GENERIC,
    [REQUEST_TYPE_UPDATE]: ERROR_MESSAGE_SAVING,
    [REQUEST_TYPE_UPLOAD]: ERROR_MESSAGE_UPLOADING_FILE,
    [REQUEST_TYPE_SEND]: ERROR_MESSAGE_GENERIC,
}

export const SUCCESS_MESSAGE_CREATE = 'Se ha creado con éxito'
export const SUCCESS_MESSAGE_DELETE = 'Se ha eliminado con éxito'
export const SUCCESS_MESSAGE_UPDATE = 'Se ha guardado con éxito'
export const SUCCESS_MESSAGE_SEND = 'Se ha enviado con éxito'

export const REQUEST_SUCCESS_MESSAGES = {
    [REQUEST_TYPE_CREATE]: SUCCESS_MESSAGE_CREATE,
    [REQUEST_TYPE_DELETE]: SUCCESS_MESSAGE_DELETE,
    [REQUEST_TYPE_UPDATE]: SUCCESS_MESSAGE_UPDATE,
    [REQUEST_TYPE_SEND]: SUCCESS_MESSAGE_SEND,
}

export const PRICE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 39.9

export const DEFAULT_REFERRAL_REWARD = 10
export const DEFAULT_DISCOUNT_PERCENTAGE = 10

export const TAX_RETURN_CELL = 505

export const CURRENCY_SYMBOL = '€'
export const CURRENCY = 'EUR'

export const REFERRAL_SLUG = 'i'

export const TWITTER_HANDLE = 'Taxfix'

export const PRODUCT_TYPE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 3 /* QuarterlyTaxReturnsAnnualSummary */
export const PRODUCT_TYPE_TAX_RETURN = 2 /* AnnualTaxReturn */
export const PRODUCT_TYPE_SELF_EMPLOYED = 1 /* SelfEmployed */
export const PRODUCT_TYPE_COMPANY = 6 /* Company */

export const ONBOARDING_SERVICE_TAX_REGISTRATION = 'taxRegistration'
export const ONBOARDING_SERVICE_QUARTERLY_TAX_RETURN = 'quarterlyTaxReturn'

export const PHONE_NUMBER_MAX_LENGTH = 20
export const PHONE_NUMBER_MIN_LENGTH = 9

export const USER_TYPE_CUSTOMER = 'Customer'
export const USER_TYPE_ACCOUNTANT = 'Accountant'
export const USER_TYPE_SYSTEM = 'System'

export const TAX_RETURN_REVIEW_SECTIONS_AMOUNT = 7

export const REFERRAL_SOURCE_REBELLION = 'REBELLION20'
export const REFERRAL_SOURCE_BLANK = 'blankreferral'

export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_BASE = '/annualSummary'
export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = '/annualSummary/:taxYear'
export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_OVERVIEW = `${PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY}/overview`
export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_OVERVIEW_PAYMENT = `${PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_OVERVIEW}/payment`
export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_UPLOADS = `${PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY}/uploads`
export const PATH_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_CONFIRMATION =
    '/confirmation/quarterlyTaxReturnsAnnualSummary/:quarterlyTaxReturnsAnnualSummaryId'
export const PATH_FINANCES = '/finances'
export const PATH_FINANCES_INVOICING = '/finances/invoicing'
export const PATH_FINANCES_TRACKING = '/finances/tracking'
export const PATH_FINANCES_TRACKING_INCOMES = '/finances/tracking/incomes'
export const PATH_FINANCES_TRACKING_EXPENSES = '/finances/tracking/expenses'
export const PATH_DASHBOARD = '/dashboard'
export const PATH_DASHBOARD_SELF_EMPLOYED_CROSS_SELL = '/dashboardSelfemployed'
export const PATH_DOCUMENTS = '/documents'
export const PATH_DOCUMENTS_OTHER = '/documents/other'
export const PATH_DOCUMENTS_AGREEMENTS = '/documents/agreements'
export const PATH_DOCUMENTS_QUARTERLY_TAX_RETURN = '/documents/quarterlyTaxReturn/:quarterlyTaxReturnId'
export const PATH_DOCUMENTS_QUARTERLY_TAX_RETURN_ANNUAL_SUMMARY =
    '/documents/quarterlyTaxReturnAnnualSummary/:quarterlyTaxReturnAnnualSummaryId'
export const PATH_DOCUMENTS_TAX_RETURN = '/documents/taxReturn/:taxReturnId'
export const PATH_IDENTITY_VERIFICATION = '/verification'
export const PATH_QUARTERLY_TAX_RETURN_BASE = '/qtr'
export const PATH_QUARTERLY_TAX_RETURN = '/qtr/:year/:quarter'
export const PATH_QUARTERLY_TAX_RETURN_INVOICING = '/qtr/:year/:quarter/invoicing'
export const PATH_QUARTERLY_TAX_RETURN_TRACKING = '/qtr/:year/:quarter/tracking'
export const PATH_QUARTERLY_TAX_RETURN_TRACKING_INCOMES = '/qtr/:year/:quarter/tracking/incomes'
export const PATH_QUARTERLY_TAX_RETURN_TRACKING_EXPENSES = '/qtr/:year/:quarter/tracking/expenses'
export const PATH_QUARTERLY_TAX_RETURN_OVERVIEW = '/qtr/:year/:quarter/overview'

export const PATH_LOGOUT = '/logout'
export const PATH_SIGNUP = '/signup'
export const PATH_SIGNUP_GOOGLE = '/signup/google'
export const PATH_LOGIN = '/login'
export const PATH_RESET_PASSWORD = '/resetPassword'
export const PATH_SET_PASSWORD = '/setPassword'

export const PATH_MAGIC_LINK = '/link/:identifier'
export const PATH_MESSAGES = '/messages'
export const PATH_MOBILE_NOTIFICATIONS = '/mobile/notifications'
export const PATH_ONBOARDING_ROOT = '/start'
export const PATH_ONBOARDING_WELCOME = '/start/welcome'
export const PATH_ONBOARDING_PROFILE_HASH_SECTION_ADDRESS = '#address'
export const PATH_ONBOARDING_PROFILE_HASH_SECTION_SELF_EMPLOYMENT = '#selfEmployment'
export const PATH_ONBOARDING_PROFILE_HASH_SECTION_FILES = '#files'
export const PATH_ONBOARDING_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = '/start/annualSummary'
export const PATH_ONBOARDING_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_BENEFITS = '/start/annualSummary/benefits'
export const PATH_ONBOARDING_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PROFILE = '/start/annualSummary/profile'
export const PATH_ONBOARDING_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PROFILE_REVIEW = '/start/annualSummary/profileReview'
export const PATH_ONBOARDING_SELF_EMPLOYED = '/start/selfEmployed'
export const PATH_ONBOARDING_SELF_EMPLOYED_PROFILE = '/start/selfEmployed/profile'
export const PATH_ONBOARDING_SELF_EMPLOYED_PROFILE_REVIEW = '/start/selfEmployed/profileReview'
export const PATH_ONBOARDING_SELF_EMPLOYED_BENEFITS = '/start/selfEmployed/benefits'
export const PATH_ONBOARDING_SELF_EMPLOYED_SERVICE_SELF_ASSIGNMENT = '/start/selfEmployed/serviceSelfAssignment'
export const PATH_ONBOARDING_TAX_RETURN = '/start/taxReturn'
export const PATH_PROFILE = '/profile'
export const PATH_PROFILE_BANK_DETAILS = '/profile/bankDetails'
export const PATH_PROFILE_EMAIL = '/profile/email'
export const PATH_PROFILE_VERIFACTU = '/profile/verifactu'
export const PATH_PROFILE_INTEGRATIONS = '/profile/integrations'
export const PATH_PROFILE_PARTNER_DETAILS = '/profile/partnerDetails'
export const PATH_PROFILE_PERKS = '/profile/perks'
export const PATH_PROFILE_SECURITY = '/profile/security'
export const PATH_PROFILE_SUBSCRIPTIONS = '/profile/subscriptions'
export const PATH_PROFILE_SUBSCRIPTIONS_HASH_BOOKKEEPING = '#bookkeeping'
export const PATH_PROFILE_SUBSCRIPTIONS_HASH_PHONE_SUPPORT = '#phoneSupport'
export const PATH_PROFILE_VERIFICATION = '/profile/verification'
export const PATH_PROFILE_WORK_ACTIVITIES = '/profile/workActivities'
export const PATH_PROFILE_WORK_ACTIVITIES_SINGLE = '/profile/workActivities/:workActivityId'
export const PATH_QUARTERLY_TAX_RETURN_LEGACY = '/quarterlyTaxReturn'
export const PATH_QUARTERLY_TAX_RETURN_LEGACY_OVERVIEW = '/quarterlyTaxReturn/overview'
export const PATH_QUARTERLY_TAX_RETURN_LEGACY_UPLOADS = '/quarterlyTaxReturn/uploads'
export const PATH_REFERRALS = '/invite'
export const PATH_ROOT = '/'
export const PATH_SOCIAL_SECURITY = '/socialSecurity'
export const PATH_SOCIAL_SECURITY_HASH_ADDRESS = '#address'
export const PATH_SOCIAL_SECURITY_HASH_AUTHORISATION = '#authorisation'
export const PATH_SOCIAL_SECURITY_HASH_MUTUAL = '#mutual'
export const PATH_SOCIAL_SECURITY_HASH_BANK_ACCOUNT = '#bankaccount'
export const PATH_SOCIAL_SECURITY_HASH_VERIFICATION = '#verification'
export const PATH_SUBSCRIPTION_PAYMENT = '/subscriptionPayment'
export const PATH_SUBSCRIPTION_PAYMENT_CONFIRMATION = '/confirmation/subscription'
export const PATH_TAX_RETURN_BASE = '/taxReturn'
export const PATH_TAX_RETURN = '/taxReturn/:taxYear'
export const PATH_TAX_RETURN_AUTHENTICATION = '/taxReturn/:taxYear/authentication'
export const PATH_TAX_RETURN_AUTHENTICATION_ADDRESS_CONFIRMATION =
    '/taxReturn/:taxYear/authentication/addressConfirmation'
export const PATH_TAX_RETURN_AUTHENTICATION_ADDRESS_CONFIRMATION_VIA_TAX_OFFICE =
    '/taxReturn/:taxYear/authentication/addressConfirmationViaTaxOffice'
export const PATH_TAX_RETURN_AUTHENTICATION_ADDRESS_UNCONFIRMED =
    '/taxReturn/:taxYear/authentication/adddressUnconfirmed'
export const PATH_TAX_RETURN_AUTHENTICATION_IDENTIFICATION = '/taxReturn/:taxYear/authentication/identification'
export const PATH_TAX_RETURN_AUTHENTICATION_METHOD = '/taxReturn/:taxYear/authentication/method'
export const PATH_TAX_RETURN_AUTHENTICATION_REVIEW = '/taxReturn/:taxYear/authentication/review'
export const PATH_TAX_RETURN_PAYMENT_CONFIRMATION = '/confirmation/taxReturn/:taxReturnId'
export const PATH_TAX_RETURN_REVIEW = '/taxReturn/:taxYear/review'
export const PATH_TAX_RETURN_REVIEW_CAPITAL_GAINS = `/taxReturn/:taxYear/review/capitalGains`
export const PATH_TAX_RETURN_REVIEW_DEDUCTIONS = `/taxReturn/:taxYear/review/deductions`
export const PATH_TAX_RETURN_REVIEW_DIVIDENDS_AND_INTERESTS = `/taxReturn/:taxYear/review/dividendsAndInterests`
export const PATH_TAX_RETURN_REVIEW_EMPLOYMENTS = `/taxReturn/:taxYear/review/employments`
export const PATH_TAX_RETURN_REVIEW_GENERAL = `/taxReturn/:taxYear/review/general`
export const PATH_TAX_RETURN_REVIEW_GENERAL_OLDER_DEPENDENT = `/taxReturn/:taxYear/review/general/data/olderDependent`
export const PATH_TAX_RETURN_REVIEW_GENERAL_YOUNGER_DEPENDENT = `/taxReturn/:taxYear/review/general/data/youngerDependent`
export const PATH_TAX_RETURN_REVIEW_PROPERTY_INCOMES = `/taxReturn/:taxYear/review/propertyIncomes`
export const PATH_TAX_RETURN_REVIEW_SELF_EMPLOYMENTS = `/taxReturn/:taxYear/review/selfEmployments`
export const PATH_TAX_RETURN_OVERVIEW = '/taxReturn/:taxYear/overview'
export const PATH_TAX_RETURN_UPLOADS = '/taxReturn/:taxYear/uploads'
export const PATH_TAX_RETURN_UPLOADS_HASH_CAPITAL_GAINS = '#capitalgains'
export const PATH_TAX_RETURN_OVERVIEW_PAYMENT = '/taxReturn/:taxYear/overview/payment'
export const PATH_TAXES = '/taxes'
export const PATH_KOINLY_CALLBACK = '/koinly'
export const PATH_WELCOME = '/welcome'

// @TODO: change path names to what they really will be
export const PATH_NEW_ONBOARDING = '/newonboarding'
export const PATH_NEW_ONBOARDING_INVOICING = `${PATH_NEW_ONBOARDING}/invoicing`
export const PATH_NEW_ONBOARDING_INVOICING_DETAILS = `${PATH_NEW_ONBOARDING_INVOICING}/details`
export const PATH_NEW_ONBOARDING_INVOICING_APPEARANCE = `${PATH_NEW_ONBOARDING_INVOICING}/appearance`
export const PATH_NEW_ONBOARDING_SELF_EMPLOYED_PROFILE = `${PATH_NEW_ONBOARDING}/selfEmployedProfile`
export const PATH_NEW_ONBOARDING_COMPANY_PROFILE = `${PATH_NEW_ONBOARDING}/companyProfile`

export const PATH_COMPANY_PAYMENT = '/company/payment'
export const PATH_COMPANY_TAX_RETURN_BASE = '/company/taxReturn'
export const PATH_COMPANY_TAX_RETURN = '/company/taxReturn/:taxYear'

export const TAX_OFFICE_AUTHENTICATION_METHOD_CLAVE_PIN = 'ClavePin'
export const TAX_OFFICE_AUTHENTICATION_METHOD_REFERENCE_NUMBER = 'ReferenceNumber'
export const TAX_OFFICE_AUTHENTICATION_METHOD_TAX_RETURN_CELL = 'TaxReturnCell'

const OWNERSHIP_TAX_OFFICE_OWNS = 'Owns'
const OWNERSHIP_TAX_OFFICE_RENTS = 'Rents'
const OWNERSHIP_TAX_OFFICE_USUFRUCT = 'Usufruct'
const OWNERSHIP_TAX_OFFICE_OTHER = 'Other'

export const OWNERSHIP_TYPES_TAX_OFFICE_LIST = [
    OWNERSHIP_TAX_OFFICE_OWNS,
    OWNERSHIP_TAX_OFFICE_RENTS,
    OWNERSHIP_TAX_OFFICE_USUFRUCT,
    OWNERSHIP_TAX_OFFICE_OTHER,
]

export const OWNERSHIP_TYPES_TAX_OFFICE_TITLES = {
    [OWNERSHIP_TAX_OFFICE_OWNS]: 'En propiedad',
    [OWNERSHIP_TAX_OFFICE_RENTS]: 'En alquiler',
    [OWNERSHIP_TAX_OFFICE_USUFRUCT]: 'Derecho de uso',
    [OWNERSHIP_TAX_OFFICE_OTHER]: 'Otro',
}

export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_OWNS = '1'
export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_USUFRUCT = '2'
export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_RENTS = '3'
export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_OTHER = '4'

export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_VALUES = {
    [OWNERSHIP_TAX_OFFICE_OWNS]: TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_OWNS,
    [OWNERSHIP_TAX_OFFICE_USUFRUCT]: TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_USUFRUCT,
    [OWNERSHIP_TAX_OFFICE_RENTS]: TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_RENTS,
    [OWNERSHIP_TAX_OFFICE_OTHER]: TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_OWNERSHIP_OTHER,
}

export const QUARTER_Q1 = 'Q1'
export const QUARTER_Q2 = 'Q2'
export const QUARTER_Q3 = 'Q3'
export const QUARTER_Q4 = 'Q4'

export const QUARTERS = [QUARTER_Q1, QUARTER_Q2, QUARTER_Q3, QUARTER_Q4]

export const QUARTER_TITLES = {
    [QUARTER_Q1]: 'Trimestre 1',
    [QUARTER_Q2]: 'Trimestre 2',
    [QUARTER_Q3]: 'Trimestre 3',
    [QUARTER_Q4]: 'Trimestre 4',
}

export const QUARTER_TITLES_SHORT = {
    [QUARTER_Q1]: 'T1',
    [QUARTER_Q2]: 'T2',
    [QUARTER_Q3]: 'T3',
    [QUARTER_Q4]: 'T4',
}

export const QUARTER_MONTHS = {
    [QUARTER_Q1]: 'ene-mar',
    [QUARTER_Q2]: 'abr-jun',
    [QUARTER_Q3]: 'jul-sep',
    [QUARTER_Q4]: 'oct-dic',
}

export const QUARTER_DATE_RANGE = {
    [QUARTER_Q1]: '1 ene - 31 mar',
    [QUARTER_Q2]: '1 abr - 30 jun',
    [QUARTER_Q3]: '1 jul - 30 sep',
    [QUARTER_Q4]: '1 oct - 31 dic',
}

export const QUARTER_DATE_RANGE_LONG = {
    [QUARTER_Q1]: 'del 1 de enero al 31 de marzo',
    [QUARTER_Q2]: 'del 1 de abril al 30 de junio',
    [QUARTER_Q3]: 'del 1 de julio al 30 de septiembre',
    [QUARTER_Q4]: 'del 1 de octubre al 31 de diciembre',
}

export const QUARTER_UPLOADS_SUGGESTED_DEADLINE = {
    [QUARTER_Q1]: '15 abr',
    [QUARTER_Q2]: '15 jul',
    [QUARTER_Q3]: '15 oct',
    [QUARTER_Q4]: '15 ene',
}

export const QUARTER_UPLOADS_SUGGESTED_EARLY_DEADLINE = {
    [QUARTER_Q1]: '12 de abril',
    [QUARTER_Q2]: '12 de julio',
    [QUARTER_Q3]: '12 de octubre',
    [QUARTER_Q4]: '15 de enero',
}

export const MONTH_NAMES_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
export const MONTH_NAMES_LONG = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
]

export const SUBSCRIPTION_STATUS_ACTIVE = 'Active'
export const SUBSCRIPTION_STATUS_CANCELLED = 'Cancelled'
export const SUBSCRIPTION_STATUS_PENDING = 'Pending'
export const SUBSCRIPTION_STATUS_FAILED = 'Failed'
export const SUBSCRIPTION_STATUS_PAST_DUE = 'PastDue'
export const SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 'IncompleteExpired'
export const SUBSCRIPTION_STATUS_UNPAID = 'Unpaid'
export const SUBSCRIPTION_STATUS_INCOMPLETE = 'Incomplete'

export const TAX_RETURN_STATUS_CREATED = 'Created'
export const TAX_RETURN_STATUS_STARTED = 'Started'
export const TAX_RETURN_STATUS_UPLOADING_DOCUMENTS = 'UploadingDocuments'
export const TAX_RETURN_STATUS_ANSWERING_QUESTIONS = 'AnsweringQuestions'
export const TAX_RETURN_STATUS_SUBMITTED = 'Submitted'
export const TAX_RETURN_STATUS_ACCOUNTANT_REVIEW = 'AccountantReview'
export const TAX_RETURN_STATUS_INFORMATION_REQUIRED = 'InformationRequired'
export const TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL = 'AwaitingCustomerApproval'
export const TAX_RETURN_STATUS_CANCELLED = 'Cancelled'
export const TAX_RETURN_STATUS_READY_TO_FILE = 'ReadyToFile'
export const TAX_RETURN_STATUS_FILED = 'Filed'
export const TAX_RETURN_STATUS_FILING_NOT_REQUIRED = 'FilingNotRequired'
export const TAX_RETURN_STATUS_COMPLETED_NOT_FILED = 'CompletedNotFiled'

export const TAX_RETURN_STATUS_ORDER = {
    [TAX_RETURN_STATUS_CREATED]: 0,
    [TAX_RETURN_STATUS_STARTED]: 10,
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 15,
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 20,
    [TAX_RETURN_STATUS_SUBMITTED]: 30,
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 40,
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 50,
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 60,
    [TAX_RETURN_STATUS_FILING_NOT_REQUIRED]: 70,
    [TAX_RETURN_STATUS_CANCELLED]: 80,
    [TAX_RETURN_STATUS_READY_TO_FILE]: 90,
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 95,
    [TAX_RETURN_STATUS_FILED]: 100,
}

export const QUARTERLY_TAX_RETURN_STATUS_ORDER = {
    [TAX_RETURN_STATUS_CREATED]: 0,
    [TAX_RETURN_STATUS_STARTED]: 10,
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 20,
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 30,
    [TAX_RETURN_STATUS_SUBMITTED]: 40,
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 50,
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 60,
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 70,
    [TAX_RETURN_STATUS_CANCELLED]: 80,
    [TAX_RETURN_STATUS_READY_TO_FILE]: 85,
    [TAX_RETURN_STATUS_FILING_NOT_REQUIRED]: 90,
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 95,
    [TAX_RETURN_STATUS_FILED]: 100,
}

export const QUARTERLY_TAX_RETURN_STATUS_PRIORITY = {
    [TAX_RETURN_STATUS_CREATED]: 0,
    [TAX_RETURN_STATUS_STARTED]: 0,
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 0,
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 0,
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 0,
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 0,
    [TAX_RETURN_STATUS_SUBMITTED]: 10,
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 10,
    [TAX_RETURN_STATUS_READY_TO_FILE]: 10,
    [TAX_RETURN_STATUS_FILED]: 10,
    [TAX_RETURN_STATUS_FILING_NOT_REQUIRED]: 100,
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 100,
    [TAX_RETURN_STATUS_CANCELLED]: 100,
}

export const QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARIES_STATUS_ORDER = {
    [TAX_RETURN_STATUS_CREATED]: 0,
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 10,
    [TAX_RETURN_STATUS_SUBMITTED]: 20,
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 30,
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 40,
    [TAX_RETURN_STATUS_CANCELLED]: 50,
    [TAX_RETURN_STATUS_FILED]: 100,
}

export const TAX_RETURN_STATUS_TITLES_FEMININE = {
    [TAX_RETURN_STATUS_CREATED]: 'Lista para iniciar',
    [TAX_RETURN_STATUS_STARTED]: 'Iniciada',
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 'Subiendo documentos',
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 'Contestando preguntas',
    [TAX_RETURN_STATUS_SUBMITTED]: 'Enviada',
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 'Preparando',
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 'Información solicitada',
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 'Esperando tu aprobación',
    [TAX_RETURN_STATUS_CANCELLED]: 'Cancelada',
    [TAX_RETURN_STATUS_READY_TO_FILE]: 'Lista para presentar',
    [TAX_RETURN_STATUS_FILED]: 'Presentada',
    [TAX_RETURN_STATUS_FILING_NOT_REQUIRED]: 'No hace falta declarar',
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 'Completada, no presentada',
}

export const RETURN_STATUS_IN_SENTENCES_FEMININE = {
    [TAX_RETURN_STATUS_CREATED]: 'Lista para iniciar',
    [TAX_RETURN_STATUS_STARTED]: 'Iniciada',
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 'En el paso de subida de documentos',
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 'En el paso de responder a preguntas',
    [TAX_RETURN_STATUS_SUBMITTED]: 'Recién enviada a tu asesor',
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 'Siendo preparada por tu asesor',
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 'Se te ha solicitado información',
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 'Esperando tu aprobación',
    [TAX_RETURN_STATUS_CANCELLED]: 'Cancelada',
    [TAX_RETURN_STATUS_READY_TO_FILE]: 'Lista para presentar',
    [TAX_RETURN_STATUS_FILED]: 'Presentada',
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 'Completada, aunque no presentada por nosotros',
}

export const TAX_RETURN_STATUS_TITLES_MASCULINE = {
    [TAX_RETURN_STATUS_CREATED]: 'Listo para iniciar',
    [TAX_RETURN_STATUS_STARTED]: 'Iniciado',
    [TAX_RETURN_STATUS_UPLOADING_DOCUMENTS]: 'Subiendo documentos',
    [TAX_RETURN_STATUS_ANSWERING_QUESTIONS]: 'Contestando preguntas',
    [TAX_RETURN_STATUS_SUBMITTED]: 'Enviado',
    [TAX_RETURN_STATUS_ACCOUNTANT_REVIEW]: 'Preparando',
    [TAX_RETURN_STATUS_INFORMATION_REQUIRED]: 'Información solicitada',
    [TAX_RETURN_STATUS_AWAITING_CUSTOMER_APPROVAL]: 'Esperando tu aprobación',
    [TAX_RETURN_STATUS_CANCELLED]: 'Cancelado',
    [TAX_RETURN_STATUS_READY_TO_FILE]: 'Listo para presentar',
    [TAX_RETURN_STATUS_FILED]: 'Presentado',
    [TAX_RETURN_STATUS_FILING_NOT_REQUIRED]: 'No hace falta declarar',
    [TAX_RETURN_STATUS_COMPLETED_NOT_FILED]: 'Completado, no presentado',
}

export const TAX_RETURN_NGO_CONTRIBUTION_TYPE_BOTH = 'Both'
export const TAX_RETURN_NGO_CONTRIBUTION_TYPE_CHURCH = 'Church'
export const TAX_RETURN_NGO_CONTRIBUTION_TYPE_NGO = 'NGO'
export const TAX_RETURN_NGO_CONTRIBUTION_TYPE_NONE = 'None'

export const PAYMENT_STATUS_UNKNOWN = 'Unknown'
export const PAYMENT_STATUS_SUCCEEDED = 'Succeeded'
export const PAYMENT_STATUS_PENDING = 'Pending'
export const PAYMENT_STATUS_FAILED = 'Failed'
export const PAYMENT_STATUS_REFUNDED = 'Refunded'

export const PAYMENT_STATUS_TITLES = {
    [PAYMENT_STATUS_UNKNOWN]: 'Desconocido',
    [PAYMENT_STATUS_SUCCEEDED]: 'Pagado',
    [PAYMENT_STATUS_PENDING]: 'Pendiente',
    [PAYMENT_STATUS_FAILED]: 'Erróneo',
    [PAYMENT_STATUS_REFUNDED]: 'Reembolsado',
}

export const SECTION_STATUS_NOT_STARTED = 'NotStarted'
export const SECTION_STATUS_CONFIRMING_DATA = 'ConfirmingData'
export const SECTION_STATUS_INCOMPLETE = 'Incomplete'
export const SECTION_STATUS_QUESTIONS_COMPLETED = 'QuestionsCompleted'
export const SECTION_STATUS_UPLOADS_COMPLETED = 'UploadsCompleted'

export const SECTION_STATUS_ORDER = {
    [SECTION_STATUS_NOT_STARTED]: 0,
    [SECTION_STATUS_CONFIRMING_DATA]: 5,
    [SECTION_STATUS_INCOMPLETE]: 10,
    [SECTION_STATUS_QUESTIONS_COMPLETED]: 20,
    [SECTION_STATUS_UPLOADS_COMPLETED]: 30,
}

export const GENDER_FEMALE = 'Female'
export const GENDER_MALE = 'Male'

export const MARITAL_STATUS_SINGLE = 'Single'
export const MARITAL_STATUS_MARRIED = 'Married'
export const MARITAL_STATUS_DIVORCED = 'Divorced'
export const MARITAL_STATUS_WIDOWED = 'Widowed'
export const MARITAL_STATUS_DEFACTOCOUPLE = 'DeFactoCouple'

export const MARITAL_STATUSES = [
    MARITAL_STATUS_SINGLE,
    MARITAL_STATUS_MARRIED,
    MARITAL_STATUS_DEFACTOCOUPLE,
    MARITAL_STATUS_DIVORCED,
    MARITAL_STATUS_WIDOWED,
]

export const MARITAL_STATUS_TITLES = {
    [MARITAL_STATUS_SINGLE]: 'Soltera/o',
    [MARITAL_STATUS_MARRIED]: 'Casada/o',
    [MARITAL_STATUS_DEFACTOCOUPLE]: 'Pareja de hecho',
    [MARITAL_STATUS_DIVORCED]: 'Divorciada/o',
    [MARITAL_STATUS_WIDOWED]: 'Viuda/o',
}

export const ADDRESS_OWNERSHIP_OWNS = 'Owns'
export const ADDRESS_OWNERSHIP_RENTS = 'Rents'
export const ADDRESS_OWNERSHIP_OTHER = 'Other'

export const ADDRESS_TYPE_HOME = 'Home'
export const ADDRESS_TYPE_BUSINESS = 'Business'
export const ADDRESS_TYPE_HOME_AND_BUSINESS = 'HomeAndBusiness'

export const PLACE_OF_BUSINESS_HOME = 'Home'
export const PLACE_OF_BUSINESS_BUSINESS = 'Business'
export const PLACE_OF_BUSINESS_OTHER = 'Other'

export const PLACE_OF_BUSINESS_TITLES = {
    [PLACE_OF_BUSINESS_HOME]: 'Vivienda',
    [PLACE_OF_BUSINESS_BUSINESS]: 'Local',
    [PLACE_OF_BUSINESS_OTHER]: 'Otro',
}

const ADDRESS_USAGE_ZERO_TO_10 = 'ZeroToTen'
const ADDRESS_USAGE_10_TO_25 = 'TenToTwentyFive'
const ADDRESS_USAGE_25_TO_50 = 'TwentyFiveToFifty'
const ADDRESS_USAGE_50_TO_75 = 'FiftyToSeventyFive'
const ADDRESS_USAGE_75_TO_100 = 'SeventyFiveToOneHundred'

export const ADDRESS_USAGE_TITLES = {
    [ADDRESS_USAGE_ZERO_TO_10]: 'Menos del 10%',
    [ADDRESS_USAGE_10_TO_25]: '10% - 25%',
    [ADDRESS_USAGE_25_TO_50]: '25% - 50%',
    [ADDRESS_USAGE_50_TO_75]: '50% - 75%',
    [ADDRESS_USAGE_75_TO_100]: '75% - 100%',
}

export const ADDRESS_USAGE_OPTIONS = [
    { title: ADDRESS_USAGE_TITLES[ADDRESS_USAGE_ZERO_TO_10], value: ADDRESS_USAGE_ZERO_TO_10 },
    { title: ADDRESS_USAGE_TITLES[ADDRESS_USAGE_10_TO_25], value: ADDRESS_USAGE_10_TO_25 },
    { title: ADDRESS_USAGE_TITLES[ADDRESS_USAGE_25_TO_50], value: ADDRESS_USAGE_25_TO_50 },
    { title: ADDRESS_USAGE_TITLES[ADDRESS_USAGE_50_TO_75], value: ADDRESS_USAGE_50_TO_75 },
    { title: ADDRESS_USAGE_TITLES[ADDRESS_USAGE_75_TO_100], value: ADDRESS_USAGE_75_TO_100 },
]

export const FILING_AREA_GENERAL = 'General'
export const FILING_AREA_EMPLOYMENT = 'Employment'
export const FILING_AREA_SELF_EMPLOYMENT = 'SelfEmployment'
export const FILING_AREA_CAPITAL_GAINS = 'CapitalGains'
export const FILING_AREA_PROPERTY = 'Property'
export const FILING_AREA_DIVIDENDS_AND_INTEREST = 'DividendsAndInterest'
export const FILING_AREA_OTHER_INCOME = 'OtherIncome'
export const FILING_AREA_PENSIONS_CONTRIBUTIONS = 'PensionsContributions'
export const FILING_AREA_CHARITABLE_GIVING = 'CharitableGiving'
export const FILING_AREA_DEDUCTIONS = 'Deductions'

export const FILE_TYPE_ANNUAL_TAX_SUMMARY = 'AnnualTaxSummary'
export const FILE_TYPE_END_OF_EMPLOYMENT = 'EndOfEmployment'
export const FILE_TYPE_PAYSLIP = 'Payslip'
export const FILE_TYPE_INCOME_RECORD = 'IncomeRecord'
export const FILE_TYPE_EXPENSE_RECORD = 'ExpenseRecord'
export const FILE_TYPE_BANK_STATEMENT = 'BankStatement'
export const FILE_TYPE_SPREADSHEET = 'Spreadsheet'
export const FILE_TYPE_PENSIONS_DOCUMENT = 'PensionsDocument'
export const FILE_TYPE_CHARITABLE_GIVING = 'CharitableGiving'
export const FILE_TYPE_OTHER = 'Other'
export const FILE_TYPE_INTEREST_CERTIFICATE = 'InterestCertificate'
export const FILE_TYPE_DIVIDEND_VOUCHER = 'DividendVoucher'
export const FILE_TYPE_PAYMENT_SCHEDULE = 'PaymentSchedule'
export const FILE_TYPE_ANNUAL_SUMMARY = 'AnnualSummary'
export const FILE_TYPE_CERTIFICATE = 'Certificate'
export const FILE_TYPE_CAPITAL_GAINS_REPORT = 'CapitalGainsReport'
export const FILE_TYPE_COMPANY_TAXABLE_BENEFITS_SUMMARY = 'CompanyTaxableBenefitsSummary'
export const FILE_TYPE_INVESTMENT_SCHEME_CERTIFICATE = 'InvestmentSchemeCertificate'
export const FILE_TYPE_PREVIOUS_RETURN = 'PreviousReturn'
export const FILE_TYPE_TAX_SCHEDULE = 'TaxSchedule'
export const FILE_TYPE_TAX_SUMMARY = 'TaxSummary'
const FILE_TYPE_IMAGE = 'Image'
export const FILE_TYPE_ID_DOCUMENT = 'IdDocument'
export const FILE_TYPE_PROOF_OF_ADDRESS = 'ProofOfAddress'
export const FILE_TYPE_TAX_REGISTRATION_SUBMISSION = 'TaxRegistrationSubmission'
export const FILE_TYPE_SOCIAL_SECURITY_AUTH_FORM = 'SocialSecurityAuthorisationForm'
export const FILE_TYPE_SOCIAL_SECURITY_NUMBER_VERIFICATION = 'SocialSecurityNumberVerification'
export const FILE_TYPE_LABOUR_DOCUMENT = 'LabourDocument'
export const FILE_TYPE_DRAFT_RETURN = 'DraftReturn'
export const FILE_TYPE_SUBMITTED_RETURN = 'SubmittedReturn'
export const FILE_TYPE_LOGO = 'Logo'

export const FILE_TYPE_TITLES = {
    [FILE_TYPE_ANNUAL_TAX_SUMMARY]: 'Resumen fiscal anual',
    [FILE_TYPE_END_OF_EMPLOYMENT]: 'Fin del empleo',
    [FILE_TYPE_PAYSLIP]: 'Nómina',
    [FILE_TYPE_INCOME_RECORD]: 'Factura / Comprobante de ventas',
    [FILE_TYPE_EXPENSE_RECORD]: 'Factura / Comprobante de gastos',
    [FILE_TYPE_BANK_STATEMENT]: 'Extracto bancario',
    [FILE_TYPE_SPREADSHEET]: 'Libro de registro',
    [FILE_TYPE_PENSIONS_DOCUMENT]: 'Documento de pensiones',
    [FILE_TYPE_OTHER]: 'Otro',
    [FILE_TYPE_INTEREST_CERTIFICATE]: 'Certificado de interés',
    [FILE_TYPE_DIVIDEND_VOUCHER]: 'Vale de dividendos',
    [FILE_TYPE_PAYMENT_SCHEDULE]: 'Calendario de pago',
    [FILE_TYPE_ANNUAL_SUMMARY]: 'Resumen anual',
    [FILE_TYPE_CERTIFICATE]: 'Certificado',
    [FILE_TYPE_COMPANY_TAXABLE_BENEFITS_SUMMARY]: 'Resumen beneficios fiscales computables',
    [FILE_TYPE_INVESTMENT_SCHEME_CERTIFICATE]: 'Certificado de inversiones',
    [FILE_TYPE_PREVIOUS_RETURN]: 'Declaraciones trimestrales anteriores',
    [FILE_TYPE_TAX_SCHEDULE]: 'Lista de impuestos',
    [FILE_TYPE_TAX_SUMMARY]: 'Resumen de impuestos',
    [FILE_TYPE_IMAGE]: 'Imagen',
    [FILE_TYPE_ID_DOCUMENT]: 'Documento de identidad',
    [FILE_TYPE_PROOF_OF_ADDRESS]: 'Prueba de domicilio',
    [FILE_TYPE_TAX_REGISTRATION_SUBMISSION]: 'Confirmación de alta',
    [FILE_TYPE_SOCIAL_SECURITY_AUTH_FORM]: 'El formulario de domiciliación bancaria',
    [FILE_TYPE_SOCIAL_SECURITY_NUMBER_VERIFICATION]: 'Verificación del número de seguro social',
    [FILE_TYPE_DRAFT_RETURN]: 'Borrador de la declaración',
    [FILE_TYPE_SUBMITTED_RETURN]: 'Declaración presentada',
    [FILE_TYPE_LOGO]: 'Logo',
    [FILE_TYPE_CAPITAL_GAINS_REPORT]: 'Informe de criptomonedas',
    [FILE_TYPE_LABOUR_DOCUMENT]: 'Documento',
    [FileTypes.PeriodAccounts]: 'Contabilidad parcial',
    [FileTypes.BookLegalizationJournal]: 'Libro diario',
    [FileTypes.BookLegalizationInventoryAndAnnualAccounts]: 'Inventario y cuentas anuales',
    [FileTypes.BookLegalizationMinutesBook]: 'Libro de actas',
    [FileTypes.BookLegalizationShareholdersBook]: 'Libro de socios',
    [FileTypes.CompanyAccountsApprovalMeetingMinutes]: 'Acta aprobación cuentas',
    [FileTypes.CompanyAccountsApprovalMinutesCertificate]: 'Certificado del acta',
    [FileTypes.CompanyAccountsApprovalMeetingMinutesSigned]: 'Acta aprobación cuentas - firmado',
    [FileTypes.CompanyAccountsApprovalMinutesCertificateSigned]: 'Certificado del acta - firmado',
    [FileTypes.CompanyAccountsReports]: 'Memoria e informes',
    [FileTypes.CompanyAnnualAccounts]: 'Cuentas anuales',
    [FileTypes.ProofOfFiling]: 'Justificante de presentación',
    [FileTypes.CompaniesHouseFilingInvoice]: 'Factura Registro Mercantil',
}

export const FILE_SUBTYPE_INCOME_TAX_RETURN = 'IncomeTaxReturn'
export const FILE_SUBTYPE_VAT_RETURN = 'VatReturn'
export const FILE_SUBTYPE_EU_VAT_FORM = 'EuVatForm'
export const FILE_SUBTYPE_WITHHOLDING_TAX_RETURN = 'WithholdingTaxReturn'
export const FILE_SUBTYPE_WITHHOLDING_TAX_DUE_RENT_FORM = 'WithholdingTaxDueRentForm'
export const FILE_SUBTYPE_WITHHOLDING_TAX_DUE_PERSONAL_INCOME_FORM = 'WithholdingTaxDuePersonalIncomeForm'
export const FILE_SUBTYPE_WITHHOLDING_TAX_DUE_INTEREST_FORM = 'WithholdingTaxDueInterestForm'

export const FILE_TYPE_WITH_SUBTYPE_TITLES = {
    [FILE_TYPE_DRAFT_RETURN]: {
        [FILE_SUBTYPE_INCOME_TAX_RETURN]: 'Modelo 130/131/202 borrador',
        [FILE_SUBTYPE_VAT_RETURN]: 'Modelo 303/420 borrador',
        [FILE_SUBTYPE_EU_VAT_FORM]: 'Modelo 369 borrador',
        [FILE_SUBTYPE_WITHHOLDING_TAX_RETURN]: 'Borrador de retenciones',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_RENT_FORM]: 'Modelo 115 borrador',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_PERSONAL_INCOME_FORM]: 'Modelo 111 borrador',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_INTEREST_FORM]: 'Modelo 123 borrador',
    },
    [FILE_TYPE_SUBMITTED_RETURN]: {
        [FILE_SUBTYPE_INCOME_TAX_RETURN]: 'Modelo 130/131/202 presentado',
        [FILE_SUBTYPE_VAT_RETURN]: 'Modelo 303/420 presentado',
        [FILE_SUBTYPE_EU_VAT_FORM]: 'Modelo 369 presentado',
        [FILE_SUBTYPE_WITHHOLDING_TAX_RETURN]: 'Retenciones presentadas',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_RENT_FORM]: 'Modelo 115 presentado',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_PERSONAL_INCOME_FORM]: 'Modelo 111 presentado',
        [FILE_SUBTYPE_WITHHOLDING_TAX_DUE_INTEREST_FORM]: 'Modelo 123 presentado',
    },
}

export const FILE_SUBTYPE_TITLES = {
    [FileSubType.WorkActivityCancellation]: 'Baja actividad',
    [FileSubType.WorkActivityRegistration]: 'Alta actividad',
}

export const FILE_OWNER_TYPE_CUSTOMER = 'Customer'

export const QUARTERLY_TAX_RETURN_FILES_FROM_ACCOUNTANT = [
    FILE_TYPE_DRAFT_RETURN,
    FILE_TYPE_SUBMITTED_RETURN,
    FILE_TYPE_OTHER,
]

export const PAYMENT_TYPE_TAX_RETURN = 'TaxReturn'
export const PAYMENT_TYPE_QUARTERLY_TAX_RETURN = 'QuarterlyTaxReturn'
export const PAYMENT_TYPE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'QuarterlyTaxReturnsAnnualSummary'

const USER_ATTRIBUTION_SOURCE_SEARCH = 'Search'
const USER_ATTRIBUTION_SOURCE_WORD_OF_MOUTH = 'WordOfMouth'
const USER_ATTRIBUTION_SOURCE_SOCIAL = 'Social'
const USER_ATTRIBUTION_SOURCE_WEBSITE = 'PartnerOrWebsite'
const USER_ATTRIBUTION_SOURCE_YOUTUBE = 'YouTube'
const USER_ATTRIBUTION_SOURCE_INFLUENCER = 'Influencer'
const USER_ATTRIBUTION_SOURCE_OTHER = 'Other'
/** @deprecated */
const USER_ATTRIBUTION_SOURCE_MEDIA = 'NewsMedia'
/** @deprecated */
const USER_ATTRIBUTION_SOURCE_TV = 'Tv'

export const USER_ATTRIBUTION_SOURCE_SELECTABLE = [
    USER_ATTRIBUTION_SOURCE_SEARCH,
    USER_ATTRIBUTION_SOURCE_WORD_OF_MOUTH,
    USER_ATTRIBUTION_SOURCE_SOCIAL,
    USER_ATTRIBUTION_SOURCE_WEBSITE,
    USER_ATTRIBUTION_SOURCE_YOUTUBE,
    USER_ATTRIBUTION_SOURCE_INFLUENCER,
    USER_ATTRIBUTION_SOURCE_OTHER,
]

export const USER_ATTRIBUTION_SOURCE_TITLES = {
    [USER_ATTRIBUTION_SOURCE_SEARCH]: 'Buscadores (Google, ChatGPT…)',
    [USER_ATTRIBUTION_SOURCE_WORD_OF_MOUTH]: 'Recomendación de un amigo o familiar',
    [USER_ATTRIBUTION_SOURCE_SOCIAL]: 'Redes sociales (Instagram, TikTok…)',
    [USER_ATTRIBUTION_SOURCE_WEBSITE]: 'Foros, blogs u otras webs',
    [USER_ATTRIBUTION_SOURCE_YOUTUBE]: 'YouTube',
    [USER_ATTRIBUTION_SOURCE_INFLUENCER]: 'Influencers',
    [USER_ATTRIBUTION_SOURCE_OTHER]: 'Otro',
    [USER_ATTRIBUTION_SOURCE_TV]: 'Anuncio de TV',
    [USER_ATTRIBUTION_SOURCE_MEDIA]: 'Prensa y medios',
}

export const MESSAGE_TEXT_TYPE_SMS = 'Sms'

export const COUNTRY_CODE_SPAIN = 'ESP'

export const SOCIAL_SECURITY_NUMBER_MAX_LENGTH = 12

export const CANARIAS_ID = 13
const COMUNIDAD_FORAL_NAVARRA_ID = 11
const PAIS_VASCO_ID = 14
export const FORAL_AUTONOMOUS_REGIONS_IDS = [CANARIAS_ID, COMUNIDAD_FORAL_NAVARRA_ID, PAIS_VASCO_ID]
export const FORAL_AUTONOMOUS_REGIONS_IDS_WITHOUT_CANARY = [COMUNIDAD_FORAL_NAVARRA_ID, PAIS_VASCO_ID]
export const ANNUAL_TAX_RETURN_DISABLED_FORAL_AUTONOMOUS_REGIONS_IDS = [COMUNIDAD_FORAL_NAVARRA_ID, PAIS_VASCO_ID]

export const STATUS_NO_REVIEW_REQUIRED = 'NoReviewRequired'
export const STATUS_UNREVIEWED = 'Unreviewed'
export const STATUS_REVIEWED = 'Reviewed'

export const OWNERSHIP_OWNS = 'Owns'
export const OWNERSHIP_RENTS = 'Rents'
export const OWNERSHIP_LEASES = 'Leases'
export const OWNERSHIP_OTHER = 'Other'

export const OWNERSHIP_TYPES_LIST = [OWNERSHIP_OWNS, OWNERSHIP_RENTS, OWNERSHIP_LEASES, OWNERSHIP_OTHER]

export const OWNERSHIP_TYPE_TITLES = {
    [OWNERSHIP_OWNS]: 'Mi propiedad',
    [OWNERSHIP_RENTS]: 'De alquiler',
    [OWNERSHIP_LEASES]: 'De alquiler con opción a compra',
    [OWNERSHIP_OTHER]: 'Otro',
}

export const OWNERSHIP_HABITUAL_RESIDENCE_TYPES_LIST = [OWNERSHIP_OWNS, OWNERSHIP_RENTS, OWNERSHIP_OTHER]

export const OWNERSHIP_HABITUAL_RESIDENCE_TITLES = {
    [OWNERSHIP_OWNS]: 'Viví todo el año como propietario',
    [OWNERSHIP_RENTS]: 'Viví todo el año de alquiler',
    [OWNERSHIP_OTHER]: 'Otro',
}

export const DISABILITY_GRADE_NONE = 'NoDisability'
export const DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT = 'DisabilityOver33LessThan65Percent'
export const DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT_REQUIRES_ASSISTANCE =
    'DisabilityOver33LessThan65PercentRequiresAssistance'
export const DISABILITY_GRADE_OVER_65_PERCENT = 'DisabilityOver65Percent'
export const DISABILITY_GRADE_JUDICIAL_INCAPACITATION = 'JudicialIncapacitation'

export const DISABILITY_GRADE_LIST = [
    DISABILITY_GRADE_NONE,
    DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT,
    DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT_REQUIRES_ASSISTANCE,
    DISABILITY_GRADE_OVER_65_PERCENT,
    DISABILITY_GRADE_JUDICIAL_INCAPACITATION,
]

export const DISABILITY_GRADE_TITLES = {
    [DISABILITY_GRADE_NONE]: 'Ninguno',
    [DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT]: 'Entre el 33 y el 65%',
    [DISABILITY_GRADE_OVER_33_LESS_THAN_65_PERCENT_REQUIRES_ASSISTANCE]: 'Entre el 33 y el 65% y requiere asistencia',
    [DISABILITY_GRADE_OVER_65_PERCENT]: 'Más del 65%',
    [DISABILITY_GRADE_JUDICIAL_INCAPACITATION]: 'Incapacitación judicial',
}

export const OLDER_DEPENDENT_RELATIONSHIPS_MAINTAXPAYER = 'MainTaxpayer'
export const OLDER_DEPENDENT_RELATIONSHIPS_PARTNER = 'Partner'

export const OLDER_DEPENDENT_RELATIONSHIPS_TITLES = {
    [OLDER_DEPENDENT_RELATIONSHIPS_MAINTAXPAYER]: 'Es mi ascendiente',
    [OLDER_DEPENDENT_RELATIONSHIPS_PARTNER]: 'Es ascendiente de mi cónyuge',
}

export const EXTERNAL_API_TYPE_TAX_OFFICE = 'TaxOffice'
export const EXTERNAL_API_TYPE_TITLES = {
    [EXTERNAL_API_TYPE_TAX_OFFICE]: 'Agencia Tributaria',
}

export const PATTERN_VALID_NIF = '[0-9]{8}[A-Za-z]{1}'
const PATTERN_VALID_NIE = '[A-Za-z]{1}[0-9]{7}[A-Za-z]{1}'
const PATTERN_VALID_CIF = '[A-Za-z]{1}[0-9]{8}'
export const PATTERN_VALID_UNIQUE_TAXPAYER_REFERENCE = `^${PATTERN_VALID_NIF}|${PATTERN_VALID_NIE}$`
export const PATTERN_VALID_UNIQUE_TAXPAYER_REFERENCE_COMPANY = `^${PATTERN_VALID_CIF}`

export const STATUS_IDLE = 'STATUS_IDLE'
export const STATUS_PENDING = 'STATUS_PENDING'
export const STATUS_RESOLVED = 'STATUS_RESOLVED'
export const STATUS_REJECTED = 'STATUS_REJECTED'

// Messaging
const KILOBYTE = 1024
const MEGABYTE = 1024 * KILOBYTE

const RESERVED_MESSAGE_CONTENT_BUFFER = 75 * KILOBYTE

export const MESSAGE_ATTACHMENT_FILE_SIZE_SUM_LIMIT = 10 * MEGABYTE - RESERVED_MESSAGE_CONTENT_BUFFER

export const MESSAGE_ATTACHMENT_FILE_MIMETYPES = [
    'text/plain', // .txt
    'application/vnd.oasis.opendocument.spreadsheet', // .ods
    'application/msword', // .doc, .dot
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //  .docx
    'application/vnd.ms-word.document.macroEnabled.12', // .docm
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xslx
    'application/vnd.ms-powerpoint', // .ppt
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'text/x-csv', // .csv,
    'text/csv', // .csv,
    'text/css', // .css
    'application/pdf', // .pdf
    'image/gif', // .gif
    'image/heic', // .heic
    'image/jpf', // .jpf
    'image/jpeg', // .jpg, .jpeg
    'image/png', // .png,
    'image/tiff', // .tif, .tiff
    'application/rtf', // .rtf
    'image/bmp', // .bmp
    'text/html', // .htm, .html
    'application/zip', // .zip,
    'application/xml', // .xml
    'text/xml', // .xml
    'application/x-tar', // .tar
    'text/calendar', // .ics
    'image/cgm', // .cgm
    'wwwserver/html-ssi', // .shtml
    'application/x-mobipocket-ebook', // .mobi
    'image/eps', // .eps
    'image/x-eps', // .eps
]

export const JOINT_TAX_RETURN_INCOME_THRESHOLD = 8000

export const IS_PASSWORD_LEAKED_STORAGE_KEY = 'should_prompt_password_change'

/**
 * Late payment interest rate ("Interés de demora")
 *
 * ⚠️ This needs to be updated every year ⚠️
 */
export const CURRENT_LATE_PAYMENT_INTEREST_RATE = 0.040625
